import React from "react";
import {
  NotificationArea,
  NotificationProvider as ToastProvider,
  ToastConsumer,
} from "@joor/design-system";
import styled from "styled-components/macro";

const ToastNotificationArea = styled(NotificationArea)`
  position: fixed;
  right: 25px;
  bottom: 25px;
  z-index: 26;
`;

export const Provider: React.FC = ({ children }) => (
  <ToastProvider>
    <ToastNotificationArea>
      <ToastConsumer />
    </ToastNotificationArea>
    {children}
  </ToastProvider>
);
